'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var userSessionStoreCore = require('@zillow/user-session-store-core');

// user actions
var SET_USER_AUTH_TOKEN = 'USER_SESSION:ACTION:SET_USER_AUTH_TOKEN';
var SET_USER_LOGGED_IN = 'USER_SESSION:ACTION:SET_USER_LOGGED_IN';

// reg login actions
var HIDE_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:HIDE_REG_LOGIN_LIGHTBOX';
var HIDE_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:HIDE_GOOGLE_ONE_TAP';
var SET_REG_LOGIN_INPUT_VALUES = 'USER_SESSION:ACTION:SET_REG_LOGIN_INPUT_VALUES';
var SET_REG_LOGIN_NODE = 'USER_SESSION:ACTION:SET_REG_LOGIN_NODE';
var SET_REG_LOGIN_PATH = 'USER_SESSION:ACTION:SET_REG_LOGIN_PATH';
var SET_REG_LOGIN_REDIRECT_URL = 'USER_SESSION:ACTION:SET_REG_LOGIN_REDIRECT_URL';
var SET_REG_LOGIN_UI_CONFIG = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG';
var SET_REG_LOGIN_UI_CONFIG_DEFAULTS = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG_DEFAULTS';
var SHOW_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:SHOW_REG_LOGIN_LIGHTBOX';
var SHOW_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:SHOW_GOOGLE_ONE_TAP';

/**
 * Forwards dispatch to global store if it exists.
 * @param  {Object} action
 *                    object describing change to be made to store
 * @return {Object} dispatched action
 */
function dispatchToUserSessionStore(action) {
    if (userSessionStoreCore.hasUserSessionStore()) {
        return userSessionStoreCore.getUserSessionStore().dispatch(action);
    }

    console.error('UserSession store is undefined');
    return null;
}

/**
 * Curry for dispatchToUserSessionStore.
 * @param {String} type - action type
 * @return {Function} curried dispatch function
 */
function dispatchOfType(type) {
    return function () {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return dispatchToUserSessionStore(_extends({ type: type }, payload));
    };
}

/**
 * Sets user.authToken.
 * @param {String} authToken - session authToken
 * @return {Object} SET_USER_AUTH_TOKEN action
 */
function setUserAuthToken(authToken) {
    if (typeof authToken === 'undefined') {
        throw new Error('no auth token specified');
    }

    return dispatchOfType(SET_USER_AUTH_TOKEN)({ authToken: authToken });
}

/**
 * Sets user.loggedIn to true.
 * @return {Object} SET_USER_LOGGED_IN action
 */
function setUserLoggedIn() {
    return dispatchOfType(SET_USER_LOGGED_IN)();
}

/**
 * Sets regLogin.inputValues.
 * @param {Object} inputValues - reg-login form input values
 * @return {Object} SET_REG_LOGIN_INPUT_VALUES action
 */
function setRegLoginInputValues(inputValues) {
    if (typeof inputValues === 'undefined') {
        throw new Error('no input values specified');
    }

    return dispatchOfType(SET_REG_LOGIN_INPUT_VALUES)({ inputValues: inputValues });
}

/**
 * Sets regLogin.node.
 * @param {DOM Node} node  - reg-login node
 * @return {Object} SET_REG_LOGIN_NODE action
 */
function setRegLoginNode(node) {
    return dispatchOfType(SET_REG_LOGIN_NODE)({ node: node });
}

/**
 * Sets regLogin.path.
 * @param {String} path - reg-login route path
 * @return {Object} SET_REG_LOGIN_PATH action
 */
function setRegLoginPath(path) {
    if (typeof path === 'undefined') {
        throw new Error('no path specified');
    }

    return dispatchOfType(SET_REG_LOGIN_PATH)({ path: path });
}

/**
 * Sets regLogin.redirectUrl.
 * @param {String} redirectUrl - reg-login redirectUrl for post submit success
 * @return {Object} SET_REG_LOGIN_REDIRECT_URL action
 */
function setRegLoginRedirectUrl(redirectUrl) {
    if (typeof redirectUrl === 'undefined') {
        throw new Error('no redirect URL specified');
    }

    return dispatchOfType(SET_REG_LOGIN_REDIRECT_URL)({ redirectUrl: redirectUrl });
}

/**
 * Sets regLogin.uiConfig. If uiConfig is not provided values will be reset
 * to their default values
 * @param {Object} uiConfig - reg-login uiConfig
 * @return {Object} SET_REG_LOGIN_UI_CONFIG action
 */
function setRegLoginUiConfig(uiConfig) {
    return dispatchOfType(SET_REG_LOGIN_UI_CONFIG)({ uiConfig: uiConfig });
}

/**
 * Sets regLogin.uiConfig with the default values. uiConfig param will
 * override values
 * @param {Object} uiConfig - reg-login uiConfig
 * @return {Object} SET_REG_LOGIN_UI_CONFIG_DEFAULTS action
 */
function setRegLoginUiConfigDefaults(uiConfig) {
    return dispatchOfType(SET_REG_LOGIN_UI_CONFIG_DEFAULTS)({ uiConfig: uiConfig });
}

/**
 * Sets regLogin.showLightbox to true.
 * @return {Object} SHOW_REG_LOGIN_LIGHTBOX action
 */
function showRegLoginLightbox() {
    return dispatchOfType(SHOW_REG_LOGIN_LIGHTBOX)();
}

/**
 * Sets regLogin.showLightbox to false.
 * @return {Object} HIDE_REG_LOGIN_LIGHTBOX action
 */
function hideRegLoginLightbox() {
    return dispatchOfType(HIDE_REG_LOGIN_LIGHTBOX)();
}

/**
 * Sets regLogin.showGoogleOneTap to false.
 * @return {Object}
 */
function hideGoogleOneTap() {
    return dispatchOfType(HIDE_GOOGLE_ONE_TAP)();
}

/**
 * Sets regLogin.showGoogleOneTap to true.
 * @return {Object}
 */
function showGoogleOneTap() {
    return dispatchOfType(SHOW_GOOGLE_ONE_TAP)();
}

exports.default = dispatchToUserSessionStore;
exports.setUserAuthToken = setUserAuthToken;
exports.setUserLoggedIn = setUserLoggedIn;
exports.setRegLoginInputValues = setRegLoginInputValues;
exports.setRegLoginNode = setRegLoginNode;
exports.setRegLoginPath = setRegLoginPath;
exports.setRegLoginRedirectUrl = setRegLoginRedirectUrl;
exports.setRegLoginUiConfig = setRegLoginUiConfig;
exports.setRegLoginUiConfigDefaults = setRegLoginUiConfigDefaults;
exports.showRegLoginLightbox = showRegLoginLightbox;
exports.hideRegLoginLightbox = hideRegLoginLightbox;
exports.hideGoogleOneTap = hideGoogleOneTap;
exports.showGoogleOneTap = showGoogleOneTap;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/@zillow/user-session-store-actions/lib/index.js
// module id = 502
// module chunks = 0